// File: frontend/src/components/common/ConnectivityBanner.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { FaWifi, FaExclamationTriangle } from "react-icons/fa";
import { useConnectivity } from "../../context/ConnectivityContext";
import "./ConnectivityBanner.css";

/**
 * Site-wide connection status strip.
 *
 * Renders nothing at all while everything is healthy, a red strip while the
 * backend is unreachable, and a green confirmation for a few seconds after
 * the connection returns — so the user is never left wondering whether the
 * app is broken or their own connection is.
 */
export const ConnectivityBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isOnline, justReconnected, checkNow } = useConnectivity();

  if (isOnline && !justReconnected) return null;

  if (!isOnline) {
    return (
      <div
        className="connectivity-banner connectivity-banner--offline"
        role="status"
        aria-live="polite"
      >
        <FaExclamationTriangle className="connectivity-banner__icon" />
        <span className="connectivity-banner__text">
          {t("connectivity_offline", "İnternet bağlantısı yok. Yeniden bağlanılıyor...")}
        </span>
        <button
          type="button"
          className="connectivity-banner__retry"
          onClick={checkNow}
        >
          {t("connectivity_retry", "Tekrar dene")}
        </button>
      </div>
    );
  }

  return (
    <div
      className="connectivity-banner connectivity-banner--online"
      role="status"
      aria-live="polite"
    >
      <FaWifi className="connectivity-banner__icon" />
      <span className="connectivity-banner__text">
        {t("connectivity_restored", "Bağlantı geri geldi.")}
      </span>
    </div>
  );
};